class GiftWithPurchase extends HTMLElement {
    constructor() {
        super();
        this.miniCart = document.querySelector("mini-cart");
        this.pageCart = document.querySelector("cart-items");
        this.enableHidePopup =
            this.querySelector("#hide-popup")?.value === "true";
        this.querySelectorAll(".gift-popup-product-variant-label").forEach(
            (variantLabel) => {
                variantLabel.addEventListener("click", (e) =>
                    this.variantSelectionHandle(e, this)
                );
            }
        );
        this.querySelector("#gift-popup-product-btn").addEventListener(
            "click",
            (e) => this.addToCart(this, e)
        );
        this.querySelector("#gift-popup-disclaimer").addEventListener(
            "click",
            async () => {
                this.hideContainer(this.querySelector("#gift-popup"));
                this.showNotch(this.querySelector("#gift-notch-container"));
                if (this.enableHidePopup) {
                    await this.setRemovedItem();
                }
            }
        );

        this.querySelector("#gift-notch-container").addEventListener(
            "click",
            (e) => {
                this.hideNotch(e);
                this.showContainer(this.querySelector("#gift-popup"));
            }
        );

        this.initGWP();
    }

    setRemovedItem = async () => {
        const cart = await fetch(`/cart.js`).then((res) => res.json());
        const gwpConfig = JSON.parse(cart.attributes["gwpConfig"] ?? "{}");
        if (gwpConfig === null) {
            await this.updateCartAttribute(
                this.querySelector("input[name='gift-variant'][checked]").value,
                this.getTriggerValue(),
                true,
                this.querySelector("input#discount-message").value ??
                    "FREE GIFT!"
            );
        } else {
            await this.updateCartAttribute(
                gwpConfig.id,
                gwpConfig.trigger,
                true
            );
        }
    };

    getClientLocation = async () => {
        try {
            const data = await fetch(
                "https://ipapi.co/json/?key=aJYAPWGh82Xn06LEl6BVhrIk39jTy0QIgPxFqAizeJJL4xp3nq"
            ).then((res) => res.json());
            return {
                provinceCode: data.region_code,
                countryCode: data.country_code,
                city: data.city,
            };
        } catch (error) {
            return { provinceCode: null, countryCode: null, city: null };
        }
    };

    async initGWP() {
        const clientData = await this.getClientLocation();
        const allowedCountries = JSON.parse(
            this.querySelector("#allowed-countries")?.value ?? "[]"
        );
        const isAllowedUser =
            allowedCountries.length === 0 ||
            allowedCountries.includes(clientData.countryCode) ||
            clientData.countryCode === null;
        const minimunAmount =
            Number(this.querySelector("#minimun-amount")?.value) || false;
        const productTrigger =
            Number(this.querySelector("#product-trigger")?.value) || false;
        const cart = await fetch(`/cart.js`).then((res) => res.json());
        const gwpConfig = JSON.parse(cart.attributes["gwpConfig"] ?? "{}");
        const [giftOnCart, overGiftsOnCart] = (() => {
            const items = cart.items.filter(
                (item) => item.properties["_isgiftproduct"]
            );
            return [items.shift() ?? false, items];
        })();
        const triggerOnCart = cart.items.some(
            (item) => item.variant_id === productTrigger
        );
        if (overGiftsOnCart.length > 0) {
            overGiftsOnCart.forEach(async (item) => {
                await this.updateGift(item.key, 0);
            });
        }
        if (minimunAmount) {
            if (cart.total_price < minimunAmount && giftOnCart) {
                await this.updateGift(giftOnCart.key, 0);
            } else if (giftOnCart.quantity > 1) {
                await this.updateGift(giftOnCart.key, 1);
            }
        } else if (productTrigger) {
            if (!triggerOnCart && giftOnCart) {
                await this.updateGift(giftOnCart.key, 0);
            } else if (giftOnCart.quantity > 1) {
                await this.updateGift(giftOnCart.key, 1);
            }
        }
        if (gwpConfig === null) {
            await this.updateCartAttribute(
                this.querySelector("input[name='gift-variant'][checked]").value,
                this.getTriggerValue(),
                true,
                this.querySelector("input#discount-message").value ??
                    "FREE GIFT!"
            );
        }
        if (!isAllowedUser) {
            if (giftOnCart) {
                await this.updateGift(giftOnCart.key, 0);
            }
            this.hideContainer(this.querySelector("#gift-popup"));
            this.querySelector("#gift-notch-container").classList.add("hidden");
            return;
        }
        if (
            !giftOnCart &&
            (triggerOnCart ||
                cart.total_price >=
                    (minimunAmount === false ? Infinity : minimunAmount))
        ) {
            if (gwpConfig.removed) {
                if (this.enableHidePopup) {
                    this.showNotch(this.querySelector("#gift-notch-container"));
                } else {
                    this.showContainer(this.querySelector("#gift-popup"));
                }
            } else {
                this.showContainer(this.querySelector("#gift-popup"));
            }
        }
    }

    showNotch(container) {
        container.classList.remove("hidden");
    }

    hideNotch(e) {
        const target = e.currentTarget;
        target.classList.add("hidden");
    }

    showContainer(container) {
        container.classList.remove("hidden");
        this.querySelector("#gift-popup").addEventListener("click", (e) =>
            this.windowClickHandle(e, container)
        );
    }

    hideContainer(container) {
        container.classList.add("hidden");
        this.querySelector("#gift-popup").removeEventListener("click", (e) =>
            this.windowClickHandle(e, container)
        );
    }

    variantSelectionHandle(e, container) {
        const target = e.currentTarget;
        const variantContainer = target.parentNode;
        const input = variantContainer.querySelector("input");
        input.checked = true;
        container
            .querySelectorAll(
                `.gift-popup-product-variant-image-${container.dataset.productId}`
            )
            .forEach((img) => {
                img.style.display = "none";
            });
        container.querySelector(
            `#gift-popup-product-variant-image-${input.value}`
        ).style.display = "block";
    }

    windowClickHandle(e, container) {
        const target = e.target;
        const overlay = container.querySelector(".gift-popup-container");
        if (target !== overlay && !overlay.contains(target)) {
            this.hideContainer(container);
            this.showNotch(this.querySelector("#gift-notch-container"));
        }
    }

    getTriggerValue() {
        return (
            {
                minimunAmount: this.querySelector("input#minimun-amount")
                    ?.value,
            } ?? {
                variantId: `gid://shopify/ProductVariant/${
                    this.querySelector("input#product-trigger")?.value
                }`,
            }
        );
    }

    async addToCart(container, e) {
        const btn = e.currentTarget;
        btn.classList.add("loading");
        btn.disabled = true;
        const variantId = container.querySelector(
            "input[name='gift-variant'][checked]"
        ).value;
        const trigger = container.getTriggerValue();
        const formData = {
            items: [
                {
                    id: variantId,
                    quantity: 1,
                    properties: {
                        _isgiftproduct: true,
                        _discounttitle:
                            container.querySelector("input#discount-message")
                                .value ?? "FREE GIFT!",
                    },
                },
            ],
        };
        if (this.miniCart) {
            formData["sections"] = this.miniCart
                .getSectionsToRender()
                .map((section) => section.id);
        }
        const responseFetch = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
        })
            .then((res) => res.json())
            .catch((e) => e);
        if (responseFetch.items.length > 0) {
            const cartAttrFetch = await this.updateCartAttribute(
                variantId,
                trigger,
                false
            );
            if (cartAttrFetch.added === true) {
                await this.updateCartDrawer(responseFetch);
                if (responseFetch.items.length > 0) {
                    container.hideContainer(
                        container.querySelector("#gift-popup")
                    );
                }
            }
        }
    }

    async updateCartAttribute(
        variantId = null,
        trigger = null,
        removed = false
    ) {
        const cart = await fetch(window.Shopify.routes.root + "cart.js").then(
            (res) => res.json()
        );
        const formData = new FormData();
        const gwpConfig =
            variantId && trigger
                ? {
                      id: `gid://shopify/ProductVariant/${variantId}`,
                      trigger,
                      removed,
                  }
                : JSON.parse(cart.attributes["gwpConfig"] ?? "{}");
        if (!variantId && !trigger) {
            gwpConfig.removed = true;
        }
        const gwpConfigStr = JSON.stringify(gwpConfig);
        formData.append("attributes[gwpConfig]", gwpConfigStr);
        const fetchResponse = await fetch(
            window.Shopify.routes.root + "cart/update.js",
            {
                method: "POST",
                body: formData,
            }
        ).then((res) => res.json());
        if (fetchResponse.attributes["gwpConfig"] !== gwpConfigStr) {
            console.error("Cart attr error");
        }
        return {
            added: fetchResponse.attributes["gwpConfig"] === gwpConfigStr,
        };
    }

    async updateCartDrawer(responseFetch) {
        if (this.miniCart) {
            this.miniCart.renderContents(responseFetch);
        }
        if (this.pageCart) {
            const parsedContent = {};
            parsedContent["sections"] = await Promise.all(
                await this.pageCart
                    .getSectionsToRender()
                    .filter((section) => section.section !== undefined)
                    .map(async (section) => {
                        if (section.section === undefined) return;
                        const res = {};
                        res[section.id] = await fetch(
                            `/?section_id=${section.section}`
                        ).then((res) => res.text());
                        return res;
                    })
            );
            parsedContent["sections"] = this.transformedObject(
                parsedContent["sections"]
            );
            this.pageCart.renderContents(parsedContent);
        }
    }

    async updateGift(id, quantity, updateCartDrawer = true) {
        const formData = {
            id: id,
            quantity: quantity,
            sections_url: window.location.pathname,
        };
        console.log("formData", formData);
        if (this.miniCart) {
            formData["sections"] = this.miniCart
                .getSectionsToRender()
                .map((section) => section.id);
        }
        const body = JSON.stringify(formData);
        const responseFetch = JSON.parse(
            await fetch(`${window.routes.cart_change_url}`, {
                ...fetchConfig(),
                ...{ body },
            }).then((res) => res.text())
        );
        if (updateCartDrawer && responseFetch)
            await this.updateCartDrawer(responseFetch);
    }

    transformedObject(originalObject) {
        return Object.keys(originalObject).reduce((acc, key) => {
            const innerObj = originalObject[key];
            Object.keys(innerObj).forEach((innerKey) => {
                acc[innerKey] = innerObj[innerKey];
            });
            return acc;
        }, {});
    }
}
customElements.define("gift-with-purchase", GiftWithPurchase);

class GiftWithPurchaseRemover extends HTMLElement {
    constructor() {
        super();
        (async () => {
            const cart = await fetch(`/cart.js`).then((res) => res.json());
            const gwpConfig = JSON.parse(cart.attributes["gwpConfig"] ?? "{}");
            const giftsOnCart = cart.items.filter(
                (item) => item.properties["_isgiftproduct"] === true
            );
            giftsOnCart.map(async (item) => {
                await this.updateGift(item.key, 0);
            });
        })();
    }

    async updateCartDrawer(responseFetch) {
        if (this.miniCart) {
            this.miniCart.renderContents(responseFetch);
        }
        if (this.pageCart) {
            const parsedContent = {};
            parsedContent["sections"] = await Promise.all(
                await this.pageCart
                    .getSectionsToRender()
                    .filter((section) => section.section !== undefined)
                    .map(async (section) => {
                        if (section.section === undefined) return;
                        const res = {};
                        res[section.id] = await fetch(
                            `/?section_id=${section.section}`
                        ).then((res) => res.text());
                        return res;
                    })
            );
            parsedContent["sections"] = this.transformedObject(
                parsedContent["sections"]
            );
            this.pageCart.renderContents(parsedContent);
        }
    }

    async updateGift(id, quantity, updateCartDrawer = true) {
        const formData = {
            id,
            quantity,
            sections_url: window.location.pathname,
        };
        if (this.miniCart) {
            formData["sections"] = this.miniCart
                .getSectionsToRender()
                .map((section) => section.id);
        }
        const body = JSON.stringify(formData);
        const responseFetch = JSON.parse(
            await fetch(`${window.routes.cart_change_url}`, {
                ...fetchConfig(),
                ...{ body },
            }).then((res) => res.text())
        );
        if (updateCartDrawer && responseFetch)
            await this.updateCartDrawer(responseFetch);
    }
}
customElements.define("gift-with-purchase-remover", GiftWithPurchaseRemover);
